import { BaseSurvey } from '../base-survey';
import { MCMMandatoryOptOutSurveyView } from './view';
import { validateAccountSettingsTriggerCondition } from '../utils';

export class MCMMandatoryOptOutSurvey extends BaseSurvey {
  getSurveyName = () => 'MCMMandatoryOptOutSurvey';

  getSurveyId = isTestEnv => isTestEnv ? // eslint-disable-line no-confusing-arrow
    'ac5d4a61-4f23-49f0-a2c8-84fa6cbdceed' : '8c853ce2-96e9-4fd9-a760-5c2b62838927';

  getSurveyProduct = () => 'ESC';

  getSurveyInterface = () => 'Web';

  validateTriggerCondition = () => validateAccountSettingsTriggerCondition(this, '/campaign/vnext/accountsettings', 'MCMMandatoryOptOutSurvey');

  onSurveySubmit = () => {
    window.survey.MCMMandatoryOptOutSurvey = false;
    window.survey.onSubmitHideWarningCallback();
  };

  onSurveyDismiss = () => {
    window.survey.MCMMandatoryOptOutSurvey = false;
    window.survey.onDismissReOptInCallback();
  };

  getSurveyComponent = () => MCMMandatoryOptOutSurveyView;
}
